module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_general-1a480eaf1ace44c9198beae3065723f5.svg";